export enum CultureIndexTraitSymbol {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  L = 'L',
  I = 'I',
}

export enum CultureIndexTraitName {
  AUTONOMY = 'autonomy',
  SOCIAL_ABILITY = 'social-ability',
  PACE = 'pace',
  CONFORMITY = 'conformity',
  LOGIC = 'logic',
  INGENUITY = 'ingenuity',
}

export interface ICultureIndexTraitSymbolMap extends Record<CultureIndexTraitSymbol, number> {}

export interface ITraitDots extends ICultureIndexTraitSymbolMap {
  EU: number
  EUText?: string
  Line: number
}
